/* HomLoom COD Form - pay online buttons + one address field + address suggestions (v2, 02 Nov 2026)
   - The form is always the Cash on Delivery form (all fields visible).
   - Under "Place Order": "or pay online" with two buttons. Pay by Card (extra 5% off, code PREPAID5) and Pay with Tamara (no extra discount).
     Each button adds the chosen deal + Shipping Protection / Mystery Box to the cart and opens Shopify checkout straight away.
   - "City / Area" field is hidden: the area is taken from the address (first part before a comma) or the emirate.
   - Address suggestions while typing: Google Places when GOOGLE_KEY is set, otherwise OpenStreetMap (Photon, free).
   Needs hl-cod.js + hl-cod-plus.js. */
(function () {
  var root = document.getElementById('hl-cod');
  if (!root || root.__hlpay) return;
  root.__hlpay = 1;

  var GOOGLE_KEY = ''; // paste a Google Maps API key (Places API enabled) here to switch suggestions to Google
  var PREPAID_CODE = 'PREPAID5';
  var PREPAID_PCT = 5;

  var cfg = {};
  try { cfg = JSON.parse(document.getElementById('hl-cod-config').textContent); } catch (e) {}
  var MF = cfg.moneyFormat || 'Dhs. {{amount}}';
  function fmt(c) {
    var a = (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return MF.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, a);
  }
  function q(s, el) { return (el || root).querySelector(s); }
  function qa(s, el) { return [].slice.call((el || root).querySelectorAll(s)); }
  function val(id) { var e = document.getElementById(id); return e ? String(e.value || '').trim() : ''; }
  function fire(el) { el.dispatchEvent(new Event('input', { bubbles: true })); el.dispatchEvent(new Event('change', { bubbles: true })); }

  /* ---------- styles ---------- */
  var css = document.createElement('style');
  css.textContent =
    '.hlc .hlcp-hide{display:none!important}' +
    '.hlc .hlc__foot .hlc__trust{display:none!important}' +
    '.hlcp-alt{margin:9px 0 0}' +
    '.hlc .hlcp-alt__or{display:flex;align-items:center;gap:8px;margin:0 0 8px!important;font-size:11px;font-weight:700;letter-spacing:.4px;text-transform:uppercase;color:#3E3832}' +
    '.hlcp-alt__or::before,.hlcp-alt__or::after{content:"";flex:1;height:1px;background:#CFC6B6}' +
    '.hlcp-alt__btns{display:grid;grid-template-columns:1fr 1fr;gap:8px}' +
    '.hlcp-alt__btns button{position:relative;display:flex;align-items:center;gap:8px;min-width:0;min-height:48px;padding:7px 9px;border:2px solid #34372B;border-radius:13px;background:#fff;cursor:pointer;font-family:var(--f);color:#1C1C18;text-align:start;transition:background .15s,transform .1s}' +
    '.hlcp-alt__btns button:active{transform:scale(.98)}' +
    '.hlcp-alt__btns button:hover{background:var(--s)}' +
    '.hlcp-alt__btns .ic{flex:0 0 auto;display:flex;align-items:center;justify-content:center;height:28px;min-width:34px;padding:0 6px;border-radius:8px;background:var(--o);color:#fff;font-size:11px;font-weight:800}' +
    '.hlcp-alt__btns .ic svg{width:18px;height:18px}' +
    '.hlcp-alt__btns .ic--tamara{background:#FCE9E1;color:#1C1C18;font-family:Georgia,serif;font-style:italic}' +
    '.hlcp-alt__btns .t{display:flex;flex-direction:column;min-width:0}' +
    '.hlcp-alt__btns b{font-size:13px;font-weight:800;line-height:1.15}' +
    '.hlc .hlcp-alt__btns small,.hlc .hlcp-alt__btns small *{font-size:10.5px!important;line-height:1.25!important;font-weight:600!important;color:#3E3832!important;letter-spacing:0!important}' +
    '.hlc .hlcp-alt__btns small{display:block;white-space:normal;overflow:visible}' +
    '.hlc .hlcp-alt__btns small s,.hlc .hlcp-alt__btns small s *{font-weight:400!important;color:#7A7066!important}' +
    '.hlc .hlcp-alt__btns b{font-size:12.5px!important}' +
    /* coloured buttons */
    '.hlc .hlcp-alt__btns button[data-pay=card]{background:#9C6B3F;border-color:#9C6B3F;color:#fff;box-shadow:0 3px 0 #6E4A28}' +
    '.hlc .hlcp-alt__btns button[data-pay=card]:hover{background:#8C5F36}' +
    '.hlc .hlcp-alt__btns button[data-pay=card] .ic{background:#fff;color:#9C6B3F}' +
    '.hlc .hlcp-alt__btns button[data-pay=card] small,.hlc .hlcp-alt__btns button[data-pay=card] small *{color:#fff!important}' +
    '.hlc .hlcp-alt__btns button[data-pay=card] small s,.hlc .hlcp-alt__btns button[data-pay=card] small s *{color:rgba(255,255,255,.72)!important}' +
    '.hlc .hlcp-alt__btns button[data-pay=card] i{background:#34372B}' +
    '.hlc .hlcp-alt__btns button[data-pay=tamara]{background:#FFE4D6;border-color:#E9B49B;box-shadow:0 3px 0 #D99C80}' +
    '.hlc .hlcp-alt__btns button[data-pay=tamara]:hover{background:#FFD9C6}' +
    '.hlc .hlcp-alt__btns button[data-pay=tamara] .ic--tamara{background:#fff}' +
    '.hlcp-alt__btns i{position:absolute;top:-9px;right:8px;padding:2px 7px;border-radius:999px;background:#9C6B3F;color:#fff;font-size:9.5px;font-style:normal;font-weight:800;white-space:nowrap}' +
    '.hlc[data-lang=ar] .hlcp-alt__btns i{right:auto;left:8px}' +
    '.hlcp-alt__btns button.is-busy{opacity:.55;pointer-events:none}' +
    '.hlc .hlcp-alt__info{margin:7px 0 0!important;padding:7px 10px;border-radius:10px;background:#EEF4EC;color:#24502D;font-size:11.5px;line-height:1.35;text-align:center}' +
    '.hlcp-ac{position:absolute;left:0;right:0;top:calc(100% - 4px);z-index:30;margin:0;padding:4px;list-style:none;background:#fff;border:1px solid var(--l);border-radius:12px;box-shadow:0 14px 28px -14px rgba(28,28,24,.45);max-height:236px;overflow:auto}' +
    '.hlcp-ac li button{display:flex;gap:8px;align-items:flex-start;width:100%;padding:9px 8px;border:0;border-radius:8px;background:transparent;cursor:pointer;text-align:start;font:13px/1.3 var(--f);color:#1C1C18}' +
    '.hlcp-ac li button:hover,.hlcp-ac li button:focus{background:var(--s);outline:0}' +
    '.hlcp-ac li button svg{flex:0 0 16px;width:16px;height:16px;margin-top:1px;color:var(--o)}' +
    '.hlcp-ac .hlcp-ac__by{padding:4px 8px 2px;font-size:10px;color:#6B635A;text-align:end}';
  document.head.appendChild(css);

  /* ---------- translations for the new text ---------- */
  var AR = window.hlcAR || {};
  var add = {
    'or pay online': 'أو ادفع أونلاين',
    'Pay by Card': 'ادفع بالبطاقة',
    'Pay with Tamara': 'ادفع مع تمارا',
    'EXTRA 5% OFF': 'خصم إضافي 5%',
    'Area, building / villa, flat no., street': 'المنطقة، المبنى / الفيلا، رقم الشقة، الشارع',
    'Opening secure checkout…': 'جارٍ فتح صفحة الدفع الآمن…',
    '2-Day Delivery is for Cash on Delivery orders only.': 'التوصيل خلال يومين متاح فقط للدفع عند الاستلام.',
    'Could not open checkout. Please try again or choose Cash on Delivery.': 'تعذر فتح صفحة الدفع. حاول مرة أخرى أو اختر الدفع عند الاستلام.'
  };
  for (var k in add) AR[k] = add[k];
  function isAr() { return root.getAttribute('data-lang') === 'ar'; }
  function T(en) { return isAr() && AR[en] ? AR[en] : en; }

  /* ---------- 1. one address field (City / Area hidden) ---------- */
  var ZONES = { AZ: 'Abu Dhabi', DU: 'Dubai', SH: 'Sharjah', AJ: 'Ajman', UQ: 'Umm Al Quwain', RK: 'Ras Al Khaimah', FU: 'Fujairah' };
  var cityIn = document.getElementById('hlc-city');
  if (cityIn) {
    var cf = cityIn.closest('.hlc__field');
    if (cf) cf.classList.add('hlcp-hide');
    cityIn.required = false;
  }
  var addrIn = document.getElementById('hlc-address');
  var help = addrIn && addrIn.closest('.hlc__field') && q('.hlc__help', addrIn.closest('.hlc__field'));
  if (help) help.textContent = 'Area, building / villa, flat no., street';
  function zoneOn() { var z = q('[data-hlc-zone-select]'); return !!(z && !z.hidden); }
  function syncCity() {
    if (!cityIn) return;
    var a = val('hlc-address');
    var seg = a.split(/[,،\n|]/)[0].trim();
    var region = zoneOn() ? (ZONES[val('hlc-region')] || '') : val('hlc-region-text');
    var city = seg.length >= 2 && seg.length <= 40 && seg !== a ? seg : (region || seg.slice(0, 40));
    if (city.length < 2) city = region || '';
    if (cityIn.value !== city) cityIn.value = city;
  }
  ['input', 'change', 'click'].forEach(function (ev) { root.addEventListener(ev, function () { setTimeout(syncCity, 0); }, true); });
  root.addEventListener('submit', function () { syncCity(); }, true);

  /* ---------- 2. "or pay online" buttons under Place Order ---------- */
  var cardIc = '<svg viewBox="0 0 24 24"><path d="M3 6h18v12H3zM3 10h18M7 15h3"/></svg>';
  var alt = document.createElement('div');
  alt.className = 'hlcp-alt';
  alt.innerHTML =
    '<p class="hlcp-alt__or"><span>or pay online</span></p>' +
    '<div class="hlcp-alt__btns">' +
      '<button type="button" data-pay="card"><i>EXTRA 5% OFF</i><span class="ic">' + cardIc + '</span><span class="t"><b>Pay by Card</b><small data-pay-amt="card"></small></span></button>' +
      '<button type="button" data-pay="tamara"><span class="ic ic--tamara">tamara</span><span class="t"><b>Pay with Tamara</b><small data-pay-amt="tamara"></small></span></button>' +
    '</div>' +
    '<p class="hlcp-alt__info" data-pay-info hidden></p>';
  var cta = q('[data-hlc-submit]');
  if (cta) cta.parentNode.insertBefore(alt, cta.nextSibling);

  function onlineBase() {
    var ad = window.hlcAddons ? window.hlcAddons() : {};
    var ex = ad && ad.express2day ? ad.express2day.price : 0; // 2-Day Delivery is COD only
    return Math.max(0, (window.__hlcBase || 0) + (window.__hlcExtra || 0) - ex);
  }
  function paintPay() {
    var base = onlineBase();
    if (!base) return;
    var card = Math.round(base * (100 - PREPAID_PCT) / 100);
    var a = q('[data-pay-amt="card"]', alt), b = q('[data-pay-amt="tamara"]', alt);
    if (a) a.innerHTML = fmt(card) + (isAr() ? ' · بدل ' : ' · was ') + '<s>' + fmt(base) + '</s>';
    if (b) b.innerHTML = '4 × ' + fmt(Math.round(base / 4)) + (isAr() ? ' · بدون فوائد' : ' · 0% interest');
  }
  window.hlcPayPaint = paintPay;

  function selectedLine() {
    var p = cfg.product;
    var offers = q('[data-hlc-offers]');
    if (!p || !p.variants || !p.variants.length) return null;
    if (!offers || offers.hidden || !q('.hlc__tag', offers)) return null; // cart mode: items are already in the cart
    var vOn = q('[data-hlc-variants] .is-on');
    var pageV = document.querySelector('.tae-buy-now-button input[name="id"], main form[action*="/cart/add"] [name="id"]');
    var vid = vOn ? Number(vOn.getAttribute('data-vid')) : (pageV && Number(pageV.value)) || p.variants[0].id;
    var tag = q('.hlc__tag.is-on');
    return { id: vid, quantity: tag && Number(tag.getAttribute('data-qty')) || 1 };
  }
  function codesOf(cart) {
    var out = [];
    (cart.cart_level_discount_applications || []).forEach(function (d) { if (d.type === 'discount_code' && d.title) out.push(d.title); });
    (cart.items || []).forEach(function (it) { (it.line_level_discount_allocations || []).forEach(function (a) { var d = a.discount_application || {}; if (d.type === 'discount_code' && d.title && out.indexOf(d.title) < 0) out.push(d.title); }); });
    return out.filter(function (c) { return c.toUpperCase() !== PREPAID_CODE; });
  }
  function goOnline(method, btn) {
    var info = q('[data-pay-info]', alt);
    qa('[data-pay]', alt).forEach(function (b) { b.classList.add('is-busy'); });
    var items = [];
    var line = selectedLine();
    if (line) items.push(line);
    var cb = q('#hlc-protection');
    if (cb && cb.checked && cfg.protection && cfg.protection.id) items.push({ id: cfg.protection.id, quantity: 1 });
    var ad = window.hlcAddons ? window.hlcAddons() : {};
    if (ad && ad.mysteryBox && ad.mysteryBox.variantId) items.push({ id: ad.mysteryBox.variantId, quantity: 1 });
    if (info) {
      info.hidden = false;
      info.textContent = T('Opening secure checkout…') + (ad && ad.express2day ? ' ' + T('2-Day Delivery is for Cash on Delivery orders only.') : '');
    }
    var step = items.length
      ? fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) }).then(function (r) { if (!r.ok) throw new Error('add'); })
      : Promise.resolve();
    step.then(function () {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).catch(function () { return {}; });
    }).then(function (cart) {
      var codes = codesOf(cart || {});
      if (method === 'card') codes.push(PREPAID_CODE); // extra 5% only for card; Tamara is already split in 4
      location.href = codes.length ? '/checkout?discount=' + encodeURIComponent(codes.join(',')) : '/checkout';
    }).catch(function () {
      qa('[data-pay]', alt).forEach(function (b) { b.classList.remove('is-busy'); });
      if (info) info.textContent = T('Could not open checkout. Please try again or choose Cash on Delivery.');
    });
  }
  alt.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pay]');
    if (b) goOnline(b.dataset.pay, b);
  });

  /* ---------- 3. address suggestions ---------- */
  var BBOX = { AE: '51.5,22.6,56.4,26.1', SA: '34.5,16.3,55.7,32.2', QA: '50.7,24.4,51.7,26.2', OM: '52,16.6,59.9,26.5', KW: '46.5,28.5,48.5,30.1', BH: '50.3,25.5,50.9,26.4' };
  var PIN = '<svg viewBox="0 0 24 24"><path d="M12 21s-7-6.2-7-11.5A7 7 0 0 1 19 9.5C19 14.8 12 21 12 21z"/><circle cx="12" cy="9.5" r="2.5"/></svg>';
  if (addrIn) {
    var field = addrIn.closest('.hlc__field') || addrIn.parentNode;
    var list = document.createElement('ul');
    list.className = 'hlcp-ac';
    list.hidden = true;
    list.setAttribute('role', 'listbox');
    field.appendChild(list);
    var timer = 0, seq = 0, gsvc = null, gLoading = false;

    function country() { return (val('hlc-country') || 'AE').toUpperCase(); }
    function show(rows, by) {
      if (!rows.length) { list.hidden = true; return; }
      list.innerHTML = rows.map(function (r) {
        return '<li><button type="button" data-ac="' + r.replace(/"/g, '&quot;') + '">' + PIN + '<span>' + r.replace(/</g, '&lt;') + '</span></button></li>';
      }).join('') + '<li class="hlcp-ac__by">' + by + '</li>';
      list.hidden = false;
    }
    function photon(text, my) {
      var cc = country();
      var url = 'https://photon.komoot.io/api/?limit=8&q=' + encodeURIComponent(text) + (BBOX[cc] ? '&bbox=' + BBOX[cc] : '') + (isAr() ? '' : '&lang=en');
      fetch(url).then(function (r) { return r.json(); }).then(function (j) {
        if (my !== seq) return;
        var seen = {}, rows = [];
        (j.features || []).forEach(function (f) {
          var p = f.properties || {};
          if (p.countrycode && p.countrycode.toUpperCase() !== cc) return;
          var parts = [p.name, p.street ? (p.housenumber ? p.housenumber + ' ' : '') + p.street : '', p.district || p.locality, p.city || p.county, p.state]
            .filter(function (x, i, a) { return x && a.indexOf(x) === i; });
          var label = parts.join(', ');
          if (label && !seen[label]) { seen[label] = 1; rows.push(label); }
        });
        show(rows.slice(0, 6), '© OpenStreetMap');
      }).catch(function () { list.hidden = true; });
    }
    function google(text, my) {
      if (!window.google || !google.maps || !google.maps.places) {
        if (!gLoading) {
          gLoading = true;
          var s = document.createElement('script');
          s.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(GOOGLE_KEY) + '&libraries=places&language=' + (isAr() ? 'ar' : 'en');
          s.async = true;
          s.onload = function () { gLoading = false; search(); };
          s.onerror = function () { GOOGLE_KEY = ''; gLoading = false; search(); };
          document.head.appendChild(s);
        }
        return;
      }
      gsvc = gsvc || new google.maps.places.AutocompleteService();
      gsvc.getPlacePredictions({ input: text, componentRestrictions: { country: country().toLowerCase() } }, function (res) {
        if (my !== seq) return;
        show((res || []).slice(0, 6).map(function (p) { return p.description; }), 'Google');
      });
    }
    function search() {
      var text = addrIn.value.trim();
      seq++;
      if (text.length < 3 || text.indexOf(' | ') > -1 || document.activeElement !== addrIn) { list.hidden = true; return; }
      if (GOOGLE_KEY) google(text, seq); else photon(text, seq);
    }
    addrIn.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(search, 300); });
    addrIn.addEventListener('blur', function () { setTimeout(function () { list.hidden = true; }, 200); });
    addrIn.addEventListener('keydown', function (e) { if (e.key === 'Escape') list.hidden = true; });
    list.addEventListener('mousedown', function (e) { e.preventDefault(); });
    list.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ac]');
      if (!b) return;
      var label = b.getAttribute('data-ac');
      addrIn.value = label + ', ';
      list.hidden = true;
      // pick the emirate automatically when it is in the suggestion
      if (zoneOn() && !val('hlc-region')) {
        for (var code in ZONES) {
          if (label.toLowerCase().indexOf(ZONES[code].toLowerCase()) > -1) { var chip = q('[data-zone="' + code + '"]'); if (chip) chip.click(); break; }
        }
      }
      fire(addrIn);
      addrIn.focus();
      try { addrIn.setSelectionRange(addrIn.value.length, addrIn.value.length); } catch (er) {}
    });
  }

  syncCity();
  paintPay();
})();
